import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';

import { Col } from 'hb-react/shared/components/DesignSystem/Grid';

export const CardHeader = ({ children }) => (
  <>
    <Box font="h3-semibold" mb={3}>
      {children}
    </Box>
    <Hr />
  </>
);

const Hr = styled.hr`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.space[5]}px;
  border-color: ${({ theme }) => theme.colors.horizon};
`;

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export const StyledCol = styled(Col).attrs({ pt: 0, pb: { _: 0, m: 6 } })`
  // I use this type of media query to avoid [ObjectObject] in dom and fit exactly the design
  @media (min-width: 768px) {
    max-width: 256px;
    margin-right: 24px;
    & > div > div {
      width: 256px;
      margin-bottom: 0 !important;
    }
  }
`;

export const BillingBlock = ({ children }) => (
  <Card bg="white" mb={5} pt={4} pl={6} pb={8}>
    {children}
  </Card>
);
